import React from 'react';

function SystemSettings() {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-2xl shadow-xl">
        <h2 className="text-2xl font-bold mb-6 text-slate-800">System Settings</h2>
        
        <div className="space-y-6">
          {/* Platform Settings */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Platform Settings</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Maintenance Mode</p>
                  <p className="text-sm text-gray-600">Temporarily disable user access</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Registration Settings</p>
                  <p className="text-sm text-gray-600">Manage user registration options</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">User Verification</p>
                  <p className="text-sm text-gray-600">Configure email and profile verification</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
            </div>
          </div>

          {/* Premium Settings */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Premium Settings</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Premium Plans</p>
                  <p className="text-sm text-gray-600">Manage membership plans and pricing</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Manage Plans
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Payment Gateway</p>
                  <p className="text-sm text-gray-600">Configure payment settings</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Subscription Management</p>
                  <p className="text-sm text-gray-600">Handle recurring payments and renewals</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
            </div>
          </div>

          {/* Content Moderation */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Content Moderation</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Auto-Moderation</p>
                  <p className="text-sm text-gray-600">Configure automated content filtering</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Blocked Keywords</p>
                  <p className="text-sm text-gray-600">Manage list of prohibited words</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Manage
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Photo Verification</p>
                  <p className="text-sm text-gray-600">Configure photo approval process</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Notifications</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Email Templates</p>
                  <p className="text-sm text-gray-600">Customize email notifications</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Edit Templates
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Push Notifications</p>
                  <p className="text-sm text-gray-600">Configure push notification settings</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">SMS Notifications</p>
                  <p className="text-sm text-gray-600">Manage SMS notification settings</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
            </div>
          </div>

          {/* Security Settings */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Security Settings</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Password Policies</p>
                  <p className="text-sm text-gray-600">Configure password requirements</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Two-Factor Authentication</p>
                  <p className="text-sm text-gray-600">Enable/disable 2FA for users</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Session Management</p>
                  <p className="text-sm text-gray-600">Configure user session timeouts</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">IP Blocking</p>
                  <p className="text-sm text-gray-600">Manage blocked IP addresses</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Manage
                </button>
              </div>
            </div>
          </div>

          {/* Privacy & Compliance */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Privacy & Compliance</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Privacy Policy</p>
                  <p className="text-sm text-gray-600">Update privacy policy document</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Edit
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Terms of Service</p>
                  <p className="text-sm text-gray-600">Update terms and conditions</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Edit
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Data Retention</p>
                  <p className="text-sm text-gray-600">Configure data retention policies</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">GDPR Compliance</p>
                  <p className="text-sm text-gray-600">Manage GDPR settings and data requests</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Manage
                </button>
              </div>
            </div>
          </div>

          {/* Backup & Recovery */}
          <div className="border-b pb-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Backup & Recovery</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Database Backup</p>
                  <p className="text-sm text-gray-600">Configure automatic database backups</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Data Export</p>
                  <p className="text-sm text-gray-600">Export platform data</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Export
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">System Restore</p>
                  <p className="text-sm text-gray-600">Restore from previous backup</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Restore
                </button>
              </div>
            </div>
          </div>

          {/* API & Integrations */}
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-4">API & Integrations</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">API Keys</p>
                  <p className="text-sm text-gray-600">Manage API access keys</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Manage
                </button>
              </div>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Third-Party Integrations</p>
                  <p className="text-sm text-gray-600">Configure external service integrations</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-800">Webhooks</p>
                  <p className="text-sm text-gray-600">Configure webhook endpoints</p>
                </div>
                <button className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
                  Configure
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Danger Zone */}
      <div className="bg-red-50 border-2 border-red-200 p-6 rounded-2xl">
        <h3 className="text-xl font-bold text-red-800 mb-4">⚠️ Danger Zone</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-semibold text-red-700">Clear All Cache</p>
              <p className="text-sm text-red-600">Remove all cached data from the system</p>
            </div>
            <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
              Clear Cache
            </button>
          </div>
          
          <div className="flex items-center justify-between">
            <div>
              <p className="font-semibold text-red-700">Reset Platform</p>
              <p className="text-sm text-red-600">Reset all platform settings to default</p>
            </div>
            <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SystemSettings;